import { autoinject } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { MemberPlan } from 'app/cd/models/essette-api';

@autoinject()
export class PrimaryPlanCustomFieldDefinitions extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    protected isThisPrimaryPlan: (plan: MemberPlan) => boolean =
        (plan: MemberPlan) => {
            return plan.isPrimary === true;
        };

    ////****************** Element References ***************************************////



    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(...rest: any[]) {
        super(...rest);
        this.logger.source = this;
    }


    ////****************** Events ***************************************************////


    ////****************** Functions ************************************************////
    protected getProperty(code: string) {
        const property = [code];
        if(/lookup/i.test(code)) {
            property.push('description');
        }
        return property.join('.');
    }

    ////****************** Service Calls ********************************************////

}
